enum MutationNames {
  CREATE_SETUP_INTENT_REQUESTED = 'CREATE_SETUP_INTENT_REQUESTED',
  CREATE_SETUP_INTENT_SUCCEEDED = 'CREATE_SETUP_INTENT_SUCCEEDED',
  CREATE_SETUP_INTENT_FAILED = 'CREATE_SETUP_INTENT_FAILED',

  SETUP_STRIPE_REQUESTED = 'SETUP_STRIPE_REQUESTED',
  SETUP_STRIPE_SUCCEEDED = 'SETUP_STRIPE_SUCCEEDED',
  SETUP_STRIPE_FAILED = 'SETUP_STRIPE_FAILED',

  CONFIRM_CARD_REQUESTED = 'CONFIRM_CARD_REQUESTED',
  CONFIRM_CARD_SUCCEEDED = 'CONFIRM_CARD_SUCCEEDED',
  CONFIRM_CARD_FAILED = 'CONFIRM_CARD_FAILED',

  SUBMIT_ORDER_REQUESTED = 'SUBMIT_ORDER_REQUESTED',
  SUBMIT_ORDER_SUCCEEDED = 'SUBMIT_ORDER_SUCCEEDED',
  SUBMIT_ORDER_FAILED = 'SUBMIT_ORDER_FAILED',
  SUBMIT_ORDER_PAYMENT_FAILED = 'SUBMIT_ORDER_PAYMENT_FAILED',

  SETUP_STRIPE_ELEMENTS_SUCCEEDED = 'SETUP_STRIPE_ELEMENTS_SUCCEEDED',

  RESET_STRIPE_MODULE = 'RESET_STRIPE_MODULE',

  LOADING_CUSTOMER_PORTAL_SESSION = 'LOADING_CUSTOMER_PORTAL_SESSION',
  RESET_CUSTOMER_PORTAL_SESSION = 'RESET_CUSTOMER_PORTAL_SESSION',
  SET_CUSTOMER_PORTAL_SESSION_ERROR = 'SET_CUSTOMER_PORTAL_SESSION_ERROR',
}

export default MutationNames;